type DownloadIconProps = {
  size?: number;
  color?: string;
};

export const DownloadIcon = ({
  size = 20,
  color = "#0069B4",
}: DownloadIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="ljo4kbk0fa"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path d="M20 0H0v20h20V0z" fill="#fff" />
    </mask>
    <g mask="url(#ljo4kbk0fa)" fill={color}>
      <path d="M17.5 18.333h-15a.832.832 0 0 1-.613-1.435.835.835 0 0 1 .613-.231h15a.834.834 0 1 1 0 1.666zM6.922 12.29l2.5 2.462a.791.791 0 0 0 1.166 0l2.488-2.462a.876.876 0 0 0 .083-1.124.792.792 0 0 0-1.243-.091l-1.077 1.077V2.498a.832.832 0 0 0-1.435-.613.834.834 0 0 0-.231.613v9.666l-1.077-1.077a.792.792 0 0 0-1.25.083.875.875 0 0 0 .076 1.12z" />
    </g>
  </svg>
);
